/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var Fn = {
    sectionCompanyTweak : function(){
      var screenWidth = $(window).width(),
      mainContainerWidth = $('.main-container').outerWidth();
      var pseudoWidth = ((screenWidth - mainContainerWidth)/2)+15;
      document.documentElement.style.setProperty('--themeWidth', screenWidth+'px');
      document.documentElement.style.setProperty('--themeright', '-'+pseudoWidth+'px');
    },
    header : function(){
      var doc = document.documentElement,
      w = window,
      bodyDom = $('body'),
      prevScroll = w.scrollY || doc.scrollTop,
      curScroll,
      direction = 0,
      prevDirection = 0,
      headerDom = $('section.header'),
      headerDomHeight = headerDom.outerHeight(),
      toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > 52) {
          headerDom.addClass('minify');
          prevDirection = direction;
          bodyDom.css('padding-top', (headerDomHeight+30) + 'px').removeClass('is-not-minified');
        }
        else if (direction === 1) {
          headerDom.removeClass('minify');
          prevDirection = direction;
          bodyDom.css('padding-top', headerDomHeight + 'px').addClass('is-not-minified');
        }
      };

      // refresh menu on resize
      var Vwindow = $(window),
      cachedWidth = Vwindow.width();

      var checkScroll = function() {

        /*
        ** Find the direction of scroll
        ** 0 - initial, 1 - up, 2 - down
        */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
          //scrolled up
          direction = 2;
        }
        else if (curScroll < prevScroll) {
          //scrolled down
          direction = 1;
        }

        if (direction !== prevDirection) {
          toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
      };

      function checkSize(){
        Vwindow.resize(function(){
          var newWidth = Vwindow.width();
          if(newWidth !== cachedWidth){
            cachedWidth = newWidth;
            checkScroll();
          }
        });
        if ($(window).width() > 991) {
          checkScroll();
        }else{
          bodyDom.css('padding-top', '75px');
        }
      }

      window.addEventListener('scroll', checkSize);
      checkSize();
    },
    customerSlider : function(){
      var slider = new Swiper('.customers .customer-slider', {
        speed : 800,
        navigation: {
          nextEl : ' .customer-slider-next',
          prevEl : ' .customer-slider-prev',
        },
        slidesPerView: 5,
        watchOverflow: true,
        watchSlidesVisibility: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 30,
          }
        }
      });
    },
    testimonySlider : function(){
      var slider = new Swiper('.testimony-slider .swiper-container', {
        speed : 800,
        spaceBetween: 30,
        navigation: {
          nextEl : ' .testimony-slider-next',
          prevEl : ' .testimony-slider-prev',
        },
        pagination: {
          el: '.testimony-slider-pagination',
          clickable: true,
        },
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesVisibility: true,
        autoplay: {
          delay: 5000,
        }
      });
    },
    testimonyScrollTo : function(){
      $(".scroll-to").click(function(event) {
        event.preventDefault();

        var defaultAnchorOffset = 0,
        anchor = $(this).attr('data-attr-scroll'),
        anchorOffset = (window.matchMedia("(min-width: 992px)").matches)?$('#'+anchor).attr('data-scroll-offset'):74;
        if (!anchorOffset){
          anchorOffset = defaultAnchorOffset;
        }

        $('html,body').animate({
          scrollTop: $('#'+anchor).offset().top - anchorOffset
        }, 1000);
      });

      var sidebar = $('.sidebar-ref'),
      body = $('body');

      $('.button-filter').click(function(e){
        e.preventDefault();
        sidebar.addClass('active');
        body.addClass('overflow-hidden');
      });
      $('.scroll-to, .make-me-sticky .close-filters').click(function(){
        sidebar.removeClass('active');
        body.removeClass('overflow-hidden');
      });
    },
    homeSlider : function(){
      var slider = new Swiper('.home-slider .swiper-container', {
        speed : 800,
        spaceBetween: 30,
        navigation: {
          nextEl : ' .home-slider-next',
          prevEl : ' .home-slider-prev',
        },
        pagination: {
          el: '.home-slider-pagination',
          clickable: true,
        },
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesVisibility: true,
        autoplay: {
          delay: 5000,
        }
      });
    },
    fakeShare : function(){
      $('.share a.social').click(function(e){
        e.preventDefault();
        var $link   = $(this);
        var href    = $link.attr('href');
        var network = $link.attr('data-network');

        var networks = {
          facebook : { width : 600, height : 300 },
          twitter  : { width : 600, height : 254 },
          google   : { width : 515, height : 490 },
          linkedin : { width : 600, height : 473 },
          pinterest : { width : 600, height : 600 }
        };

        var x = screen.width/2 - networks[network].width/2;
        var y = (screen.height/2 - networks[network].height/2)-200;

        var popup = function(network){
          var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
          window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width+',left='+x+',top='+y);
        };

        popup(network);
      });
    }
  };

  var Ajax = {
    init : function(){
      $(document).on('click', '.articles-loadmore', function(e) {
        e.preventDefault();
        var _this = $(this);
        Ajax.loadMore(_this, 'loadmoreArticles', '.article-results', _this);
      });
    },
    loadMore: function (button, ajaxAction, listID, loader) {
      var currentPage = button.attr('data-current-page'),
      maxNumPages = button.attr('data-max-num-pages'),
      exclude = button.attr('data-exclude'),
      data = {
        'action': ajaxAction,
        'current_page' : currentPage,
        'exclude' : exclude,
        'is_ajax' : true
      };

      button.attr('disabled','disabled');

      $.ajax({
        url : Config.ajax_url,
        data : data,
        type : 'POST',
        beforeSend : function ( xhr ) {
          loader.addClass('active');
        },
        success : function( data ){
          if( data ) {
            $(listID).append(data);

            currentPage = parseInt(currentPage)+1;
            button.attr('data-current-page', currentPage);

            button.removeAttr('disabled');
            loader.removeClass('active');

            if (currentPage >= maxNumPages) {
              button.remove();
            }
          } else {
            button.remove(); // if no data, remove the button as well
          }
        }
      }); // end Ajax
    },
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        Fn.header();
        Fn.customerSlider();
        // Cookie mobile
        $('.load-mobile-cookie').click(function(e){
          e.preventDefault();
          $('.mobile-close').click();
          $('#cookie-law-info-again').click();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'page_template_template_home': {
      init: function() {
        Fn.homeSlider();
        Fn.testimonySlider();
        Fn.customerSlider();
      }
    },
    'page_template_template_my_transport': {
      init: function() {
        //Change section.module-xxx:before width & left property base on screen resolution
        Fn.sectionCompanyTweak();
        $(window).on('resize',function(){
          Fn.sectionCompanyTweak();
        });
        Fn.testimonySlider();
        Fn.testimonyScrollTo();
      }
    },
    'page_id_143': {//Devis
      init: function() {
        var radios = ['frm_radio_25-0','frm_radio_25-1','frm_radio_25-2'];
        $('.frm_image_option').each(function(){
          var text = $(this).find('.frm_text_label_for_image_inner'),
          textData = text.text(),
          id = $(this).attr('id');

          if($.inArray( id, radios ) !== -1){
            if(id === 'frm_radio_25-0'){
              text.html('Transport <span class="bold d-block">extrême urgence</span><span class=" d-block text-dark-gray delivery">Livraison directe garantie</span>');
            }else if(id === 'frm_radio_25-1'){
              text.html('Transport <span class="bold d-block">urgent</span><span class=" d-block text-dark-gray delivery">Livraison à J+1 garantie</span>');
            }else if(id === 'frm_radio_25-2'){
              text.html('Transport <span class="bold d-block">non urgent</span><span class=" d-block text-dark-gray delivery">Livraison à partir de 24H</span>');
            }
          }
        });
        $('#field_xh97x_label').html('J\'accepte la <a href="'+Config.page_confidentiality+'" class="text-orange">politique de protection des données personnelles</a><span class="frm_required" aria-hidden="true">*</span>');
        $(document).on( 'frmFormComplete', function( event, form, response ) {
          $('.to-hide').hide();
          $('.to-change').removeClass('bg-white').addClass('bg-blue');
          $('html,body').animate({
            scrollTop: $('.main-estimate').offset().top - ($('.header').height()+100)
          }, 1000);
        });
      }
    },
    'page_id_98': {//Contact
      init: function() {
        $('#field_xh97x1bcb5974be_label').html('J\'accepte la <a href="'+Config.page_confidentiality+'" class="text-orange">politique de protection des données personnelles</a><span class="frm_required" aria-hidden="true">*</span>');
        $(document).on( 'frmFormComplete', function( event, form, response ) {
          $('.to-hide').hide();
          $('.to-change').removeClass('bg-white').addClass('bg-blue');
          $('html,body').animate({
            scrollTop: $('.main-estimate').offset().top - ($('.header').height()+100)
          }, 1000);
        });
      }
    },
    'single_post': {//News detail
      init: function() {
        Fn.testimonySlider();
        Fn.fakeShare();
        var sidebar = $('.sidebar-ref'),
        body = $('body');
        $('.button-filter').click(function(e){
          e.preventDefault();
          sidebar.addClass('active');
          body.addClass('overflow-hidden');
        });
        $('.make-me-sticky .close-filters').click(function(){
          sidebar.removeClass('active');
          body.removeClass('overflow-hidden');
        });
      }
    },
    'page_template_template_news': {//News listing
      init: function() {
        Ajax.init();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  $('.label-radio-custom input[type="radio"]').on('change', function() {
    var value = $(this).val();

    // On cible le wrapper CF7 du champ "urgence"
    var wrap = $('.wpcf7-form-control-wrap[data-name="urgence"]');

    // On coche le bon input CF7
    var target = wrap.find('.wpcf7-radio input[type="radio"][value="' + value + '"]');
    target.prop('checked', true).trigger('change');

    // On enlève l'état "non valide"
    wrap.find('.wpcf7-form-control').removeClass('wpcf7-not-valid');
    wrap.find('.wpcf7-not-valid-tip').remove();
  });

})(jQuery); // Fully reference jQuery after this point.
